module.exports = __webpack_public_path__ + "officialStatic/img/soft10.ff88c79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft10.png
// module id = F8/j
// module chunks = 0